import { render } from "./SubFormItemGroup.vue?vue&type=template&id=0c95fe4e&scoped=true&ts=true"
import script from "./SubFormItemGroup.vue?vue&type=script&lang=ts"
export * from "./SubFormItemGroup.vue?vue&type=script&lang=ts"

import "./SubFormItemGroup.vue?vue&type=style&index=0&id=0c95fe4e&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c95fe4e"]])

export default __exports__